export default function LLCIcon() {
  return (
    <svg width="97" height="101" viewBox="0 0 97 101" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.6"
        d="M46.7587 18.5C46.3887 19.8875 46.25 21.4137 46.25 23.125V37H23.125V27.75C23.125 22.6625 27.2875 18.5 32.375 18.5H46.7587Z"
        fill="url(#paint0_linear_356_7161)"
      />
      <path
        d="M46.25 87.875V37H23.125C13.875 37 9.25 41.625 9.25 50.875V87.875C9.25 97.125 13.875 101.75 23.125 101.75H60.125C50.875 101.75 46.25 97.125 46.25 87.875ZM31.2188 78.625C31.2188 80.5213 29.6462 82.0938 27.75 82.0938C25.8538 82.0938 24.2812 80.5213 24.2812 78.625V60.125C24.2812 58.2288 25.8538 56.6562 27.75 56.6562C29.6462 56.6562 31.2188 58.2288 31.2188 60.125V78.625Z"
        fill="url(#paint1_linear_356_7161)"
      />
      <path
        opacity="0.4"
        d="M64.75 101.75H60.125C50.875 101.75 46.25 97.125 46.25 87.875V23.125C46.25 13.875 50.875 9.25 60.125 9.25H87.875C97.125 9.25 101.75 13.875 101.75 23.125V87.875C101.75 97.125 97.125 101.75 87.875 101.75H83.25"
        fill="url(#paint2_linear_356_7161)"
      />
      <path
        d="M83.25 83.25V101.75H64.75V83.25C64.75 80.7062 66.8312 78.625 69.375 78.625H78.625C81.1688 78.625 83.25 80.7062 83.25 83.25Z"
        fill="url(#paint3_linear_356_7161)"
      />
      <path
        d="M64.75 63.5938C62.8537 63.5938 61.2812 62.0212 61.2812 60.125V37C61.2812 35.1037 62.8537 33.5312 64.75 33.5312C66.6462 33.5312 68.2188 35.1037 68.2188 37V60.125C68.2188 62.0212 66.6462 63.5938 64.75 63.5938Z"
        fill="url(#paint4_linear_356_7161)"
      />
      <path
        d="M83.25 63.5938C81.3537 63.5938 79.7812 62.0212 79.7812 60.125V37C79.7812 35.1037 81.3537 33.5312 83.25 33.5312C85.1462 33.5312 86.7188 35.1037 86.7188 37V60.125C86.7188 62.0212 85.1462 63.5938 83.25 63.5938Z"
        fill="url(#paint5_linear_356_7161)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_356_7161"
          x1="25.2025"
          y1="27.7501"
          x2="44.6032"
          y2="27.7501"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B5CDF7" stop-opacity="0.5" />
          <stop offset="1" stop-color="#CDDFF0" stop-opacity="0.5" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_356_7161"
          x1="13.7221"
          y1="69.3753"
          x2="55.485"
          y2="69.3753"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B5CDF7" stop-opacity="0.5" />
          <stop offset="1" stop-color="#CDDFF0" stop-opacity="0.5" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_356_7161"
          x1="51.1287"
          y1="55.5005"
          x2="96.6881"
          y2="55.5005"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B5CDF7" stop-opacity="0.5" />
          <stop offset="1" stop-color="#CDDFF0" stop-opacity="0.5" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_356_7161"
          x1="66.3762"
          y1="90.1876"
          x2="81.5627"
          y2="90.1876"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B5CDF7" stop-opacity="0.5" />
          <stop offset="1" stop-color="#CDDFF0" stop-opacity="0.5" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_356_7161"
          x1="61.8911"
          y1="48.5627"
          x2="67.586"
          y2="48.5627"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B5CDF7" stop-opacity="0.5" />
          <stop offset="1" stop-color="#CDDFF0" stop-opacity="0.5" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_356_7161"
          x1="80.3911"
          y1="48.5627"
          x2="86.086"
          y2="48.5627"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B5CDF7" stop-opacity="0.5" />
          <stop offset="1" stop-color="#CDDFF0" stop-opacity="0.5" />
        </linearGradient>
      </defs>
    </svg>
  );
}
